import React, { Suspense, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import { changeNetworkConnection, checkNetworkConnection } from "../modules/common";
import { PAGE_NOT_FOUND } from "../modules/language";
import { ErrorPage } from "../components/shared/ErrorPage";
import { Header } from "../components/shared/Header";
import { Footer } from "../components/shared/Footer";
import { Home } from "../components/pages/Home";
import { Contatti } from "../components/pages/Contatti";
import { Faq } from "../components/pages/faq/Faq";
import { Informativa } from "../components/pages/informativa/Informativa";
import { Cerca } from "../components/pages/cerca/Cerca";
import { Monitora } from "../components/pages/monitora/Monitora";
import { PATH_HOME, PATH_CERCA, PATH_MONITORA, PATH_CONTATTI, PATH_FAQ, PATH_INFORMATIVA } from "../path";
import { getMessageString } from "../tools";

const PageNotFoundBase = ({ intl }) => <div>{getMessageString(intl, PAGE_NOT_FOUND)}</div>;
const PageNotFound = injectIntl(PageNotFoundBase);

export const SwitchContent = () => {
  const isNetworkConnected = useSelector(checkNetworkConnection);
  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener("online", () => {
      if (!isNetworkConnected) dispatch(changeNetworkConnection(true));
    });

    window.addEventListener("offline", () => {
      if (isNetworkConnected) dispatch(changeNetworkConnection(false));
    });
    // eslint-disable-next-line
  }, [isNetworkConnected]);

  return (
    <div id="mainContent">
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route exact path="/" render={() => <Redirect to={PATH_HOME} />} />
          <Route
            exact
            path={PATH_HOME + "/:idStruttura?"}
            render={(routeProps) => <Home idStruttura={routeProps.match.params.idStruttura} />}
          />
          <Route exact path={PATH_CERCA}>
            <Header />
            <Cerca />
            <Footer />
          </Route>
          <Route exact path={PATH_MONITORA}>
            <Header backEnabled={true} />
            <Monitora />
            <Footer />
          </Route>
          <Route exact path={PATH_CONTATTI}>
            <Header backEnabled={true} />
            <Contatti />
            <Footer />
          </Route>
          <Route exact path={PATH_FAQ}>
            <Header backEnabled={true} />
            <Faq />
            <Footer />
          </Route>
          <Route exact path={PATH_INFORMATIVA}>
            <Header backEnabled={true} />
            <Informativa />
            <Footer />
          </Route>
          <Route path="*" exact={true}>
            <ErrorPage errorMessage={<PageNotFound />} />
          </Route>
        </Switch>
      </Suspense>
    </div>
  );
};
